interface CoderSkill {
  skill_tag: number | null
  skill_tag_string: string | null
  is_main: number | null
}

interface CoderCareerTag {
  career_tag1: number | null
  career_tag1_string: string | null
  career_tag2: number | null
  career_tag2_string: string | null
}

interface CoderIndustryExperience {
  industry_tag: number | null
  industry_tag_string: string | null
}

export interface Coder {
  id: number
  nickname: string | null
  avatar: string | null
  work_years: string | null
  city_string: string | null
  success_rate: number | null
  recently_active_string: string | null
  is_job_seeking: number | null
  freelance_status: number | null
  skills: CoderSkill[]
  career_tags: CoderCareerTag[]
  industry_experiences: CoderIndustryExperience[]
}

export interface CodersResponse {
  data: Coder[]
  pagination: {
    total: number
    page: number
    page_size: number
    total_pages: number
  }
}

export interface CodersParams {
  careerTag2?: number
  onlyFather?: boolean
  industryTag?: number
  carrierTag?: number
  city?: number
  isFreelance?: number
  isJobSeeking?: number
  page?: number
}

const API_BASE = process.env.NEXT_PUBLIC_API_URL || "http://localhost:8000"

// Create timeout wrapper for fetch
async function fetchWithTimeout(url: string, options: RequestInit = {}, timeout = 10000): Promise<Response> {
  const controller = new AbortController()
  const id = setTimeout(() => controller.abort(), timeout)

  try {
    const response = await fetch(url, {
      ...options,
      signal: controller.signal,
    })
    clearTimeout(id)
    return response
  } catch (error) {
    clearTimeout(id)
    if (error instanceof Error && error.name === 'AbortError') {
      throw new Error(`Request timeout after ${timeout}ms`)
    }
    throw error
  }
}

export async function fetchCoders(params: CodersParams = {}): Promise<CodersResponse> {
  const searchParams = new URLSearchParams()

  // Only add params that are not undefined
  if (params.careerTag2 !== undefined) searchParams.append("careerTag2", params.careerTag2.toString())
  if (params.onlyFather !== undefined) searchParams.append("onlyFather", params.onlyFather.toString())
  if (params.industryTag !== undefined) searchParams.append("industryTag", params.industryTag.toString())
  if (params.carrierTag !== undefined) searchParams.append("carrierTag", params.carrierTag.toString())
  if (params.city !== undefined) searchParams.append("city", params.city.toString())
  if (params.isFreelance !== undefined) searchParams.append("isFreelance", params.isFreelance.toString())
  if (params.isJobSeeking !== undefined) searchParams.append("isJobSeeking", params.isJobSeeking.toString())
  if (params.page !== undefined) searchParams.append("page", params.page.toString())

  const url = `${API_BASE}/api/v1/coders?${searchParams.toString()}`
  console.log(`API Request: ${url}`)
  console.log(`API_BASE: ${API_BASE}`)

  const response = await fetchWithTimeout(
    url,
    {
      cache: "no-store",
      headers: {
        'Accept': 'application/json',
      },
    },
    15000 // 15 second timeout
  )

  console.log(`API Response status: ${response.status}`)

  if (!response.ok) {
    throw new Error(`Failed to fetch coders: ${response.statusText} (${response.status})`)
  }

  const data = await response.json()
  console.log(`API Response data count: ${data.data?.length || 0}`)
  return data
}
